import React from "react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";

const renderStatus = (code) => {
    if (!code) return "⏸️ En attente";

    if (code === 202) return "⏳ En cours";
    if (code === 200) return "✅ Succès";
    if (code === 500) return "❌ Erreur";
    if (code === 503) return "🔁 Réessai";
    if (code === 100) return "ℹ️ Info";

    return code;
};

const getBadgeVariantForStatus = (code) => {
    if (!code) return "outline";
    if (code === 202) return "default";
    if (code === 200) return "secondary";
    if (code === 500) return "destructive";
    if (code === 503) return "outline";
    if (code === 100) return "outline";
    return "outline";
};

const ImportLogsCards = ({ logs }) => {
    if (!logs || logs.length === 0) return null;

    return (
        <div className="space-y-3">
            {logs.map((log, i) => (
                <Card key={log.id || i} className="border-border">
                    <CardContent className="p-4 space-y-2">
                        <div className="flex items-center justify-between">
                            <span className="text-xs font-medium text-muted-foreground">
                                {new Date(log.date).toLocaleString("fr-FR")}
                            </span>
                            <Badge variant={getBadgeVariantForStatus(log.http_status)}>
                                {renderStatus(log.http_status)}
                            </Badge>
                        </div>
                        <div className="text-xs text-muted-foreground truncate">{log.uuid}</div>
                        <p className="text-sm text-foreground line-clamp-2">{log.message || "—"}</p>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};

export default ImportLogsCards;
